var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "thumbs-up_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.166 6.543h1.905c5.623 0 10.182 4.56 10.182 10.183v5.091h26.042l-7.425 35.64H3.705V28.182h12.096zm-7.005 26.73H8.797v19.092h6.364z",
    clipRule: "evenodd"
  })));
};
export { SvgThumbsUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIyLjE2NTggNi41NDM0NkgyNC4wNzA2QzI5LjY5NDIgNi41NDM0NiAzNC4yNTMyIDExLjEwMjQgMzQuMjUzMiAxNi43MjYxVjIxLjgxNzRINjAuMjk0OEw1Mi44Njk5IDU3LjQ1NjZIMTcuNzA2NEgxNS4xNjA4SDYuMjUwOThIMy43MDUzMlY1NC45MTFWMzAuNzI3MlYyOC4xODE2SDYuMjUwOThIMTUuODAxN0wyMi4xNjU4IDYuNTQzNDZaTTE1LjE2MDggMzMuMjcyOUg4Ljc5NjY0VjUyLjM2NTNIMTUuMTYwOFYzMy4yNzI5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";